module.exports = __webpack_public_path__ + "fonts/600-700-normal-cyrillic-ext.37f8885.woff2";